import './App.scss';
import Header from './components/Header';
import Footer from './components/Footer';
import GameContainer from './components/GameContainer';

function App() {
  return (
    <>
      <Header/>
      <GameContainer />
      <Footer />
    </>
  );
}

export default App;
